

























































































































































































import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { quanxianMixin } from "@/mixins/quanxianMixin";
import MainHeader from "@/components/main-header/main-header.vue";
import {
  GetShitiNav,
  GetYuyileixingNav,
  DeleteShiti,
} from "@/request/storehouse";
import { PatchConceptualEntity } from "@/request/common";
import ShitiCompose from "@/components/shiti-compose.vue";
import AddShiti from "../components/add-shiti.vue";
import EditShiti from "@/components/edit-shiti.vue";
@Component({
  components: {
    MainHeader,
    ShitiCompose,
    AddShiti,
    EditShiti,
  },
})
export default class Name extends mixins(quanxianMixin) {
  private clickData: any = {};
  private clickType: any = "";
  private search: any = "";
  private type: any = "";
  private props: any = {
    label: "名称",
  };
  private tabType: any = "标准库";
  private treeKey: number = Date.now();
  private shitiData: any = {};
  private ifShowAddShiti: boolean = false;
  private yuyiData: any = {};
  private ifShowEditShiti: boolean = false;
  private currentNodeData: any = {};
  private showThreeButtonConfirm: boolean = false;
  private currentUnbindData: any = {};

  private get currentKu() {
    return this.$store.state.currentKu;
  }

  private get kuList() {
    return this.$store.state.kuList;
  }
  private editSure(res: any) {
    this.ifShowEditShiti = false;
    // 清空当前的选择
    this.clickData = {};
    this.clickType = "";
    this.shitiData = {};
    // 刷新树
    this.refreshTree();
  }

  private addSure() {
    this.ifShowAddShiti = false;
    // 刷新当前选中节点的子节点
    const tree: any = this.$refs.tree;
    if (tree && this.clickData.uid) {
      const node = tree.getNode(this.clickData.uid);
      if (node) {
        // 清空当前节点的子节点
        node.childNodes = [];
        // 重新加载子节点
        this.loadNode(node, (children: any) => {
          tree.updateKeyChildren(node.key, children);
        });
      }
    }
  }

  private changeTab(tab: any) {
    this.tabType = tab;
    this.clickData = {};
    this.clickType = "";
    this.refreshTree();
  }

  private getShitiData(data: any) {
    this.shitiData = data;
    this.yuyiData = {
      label: data["语义类型"],
      域名称: data["语义类型"],
      _id: data["语义id"],
      域id: data["语义id"],
    };

    // 更新树节点显示
    const tree: any = this.$refs.tree;
    if (tree && this.clickData.uid) {
      const node = tree.getNode(this.clickData.uid);
      if (node && node.data) {
        // 更新节点数据
        node.data.名称 = data["实体名称"];
        // 更新状态
        node.data.是否临时 = data["是否临时"];
        // 只更新当前节点，保持子节点不变
        const parent = node.parent;
        if (parent) {
          const index = parent.childNodes.indexOf(node);
          if (index > -1) {
            parent.childNodes[index] = node;
            // 强制更新节点
            node.expanded = node.expanded;
          }
        }
      }
    }
  }

  private handleCommand(command: any) {
    console.log("点击扩展按钮");
    console.log(this.clickData);
    if (command.command == "删除") {
      this.$confirm(
        "删除后该实体及下属的子内容将全部删除，您确定需要删除么？",
        "删除",
        {
          customClass: "commonConfirm",
        }
      ).then(() => {
        DeleteShiti(this, command.data._id).then((res: any) => {
          this.$message.success("删除成功");
          // 清空当前的选择
          this.clickData = {};
          this.clickType = "";
          this.shitiData = {};
          // 刷新树
          this.refreshTree();
          this.$message.success("删除成功");
          // const tree: any = this.$refs.tree;
          // if (tree && command.data.uid) {
          //   const node = tree.getNode(command.data.uid);
          //   if (node) {
          //     tree.remove(node);
          //   }
          //   tree.setCurrentKey(null);
          // }
          // this.clickData = {};
          // this.clickType = "";
          // this.shitiData = {};
        });
      });
    } else if (command.command == "修改语义类型") {
      this.ifShowEditShiti = true;
    } else if (command.command == "添加") {
      this.ifShowAddShiti = true;
    } else if (command.command == "解绑") {
      const parent = this.currentNodeData.parent.data;
      const shangweigainian = this.shitiData["上位概念"];
      console.log("解绑");
      console.log(parent);
      console.log(shangweigainian);
      console.log(this.shitiData);
      // 这里分2种情况处理
      //1、如果shangweigainian只有1个，且这个的id和parent里面的_id是一样，就提示不能解绑
      //2、如果shangweigainian有多个，且有一个的id和parent里面的_id一样，就提示正在解绑
      if (shangweigainian.length == 1) {
        if (shangweigainian[0].id == parent._id) {
          // 使用3按钮对话框
          this.currentUnbindData = {
            parent: parent,
            shitiData: this.shitiData,
            shangweigainian: shangweigainian,
          };
          this.showThreeButtonConfirm = true;
          return;
        }
      } else if (shangweigainian.length > 1) {
        if (shangweigainian.some((item: any) => item.id == parent._id)) {
          this.$confirm("是否确认将该实体从当前上位概念下移除？", "解绑", {
            customClass: "commonConfirm",
          }).then(() => {
            // 编辑
            const params: any = {
              语义类型: this.shitiData["语义类型"],
              上位概念: shangweigainian.filter(
                (item: any) => item.id != parent._id
              ),
            };
            const loading = this.$loading({
              lock: true,
              text: "加载中……",
              spinner: "el-icon-loading",
              customClass: "loadClass",
              background: "rgba(255, 255, 255, 0.7)",
            });
            PatchConceptualEntity(
              this,
              this.shitiData.id,
              params,
              loading
            ).then((res: any) => {
              loading.close();
              this.$message.success("解绑成功");
              // 清空当前的选择
              this.clickData = {};
              this.clickType = "";
              this.shitiData = {};
              // 刷新树
              this.refreshTree();
            });
          });
        }
      }
    }
  }

  private refreshTree() {
    this.treeKey = Date.now();
  }

  private goSearch() {
    if (!this.search) {
      this.$message.warning("请输入关键字！");
      return;
    }
    const d: any = {
      searchText: this.search,
      source: "实体库",
    };
    this.$store.commit("updateCurrentKu", this.type);
    localStorage.setItem("searchFilter", "");
    this.$router.push({
      path: "/main/storehouse/search",
      query: {
        data: JSON.stringify(d),
      },
    });
  }

  private handleNodeClick(data: any, node: any) {
    this.clickData = data;
    this.currentNodeData = node;
    this.$store.commit("updateIfCompose", false);
    this.clickType = node.data["类型"];
    if (data["类型"] == "语义类型") {
      this.yuyiData = {
        label: data["名称"],
        域名称: data["名称"],
        _id: data._id,
        域id: data._id,
      };
      this.shitiData = {};
    }
  }

  private loadNode(node: any, resolve: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });

    const params: any = {
      params: {
        语义类型id: "",
        实体id: "",
        // tabType: this.tabType,
      },
    };

    if (node.data && node.data._id) {
      if (node.data["类型"] == "语义类型") {
        params.params["语义类型id"] = node.data._id;
      } else if (node.data["类型"] == "实体") {
        params.params["实体id"] = node.data._id;
      }
    }

    let data: any = [];
    GetShitiNav(this, params)
      .then((res: any) => {
        loading.close();
        if (res.length > 0) {
          data = res;
        }
        const params2: any = {
          params: {
            _id: node.data ? node.data._id : "",
          },
        };
        const loading2 = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        GetYuyileixingNav(this, params2, loading2)
          .then((d: any) => {
            loading2.close();
            if (d.length > 0) {
              data = data.length > 0 ? d.concat(data) : d;
            }
            resolve(data);
          })
          .catch(() => {
            loading2.close();
          });
      })
      .catch(() => {
        loading.close();
      });
  }

  // 3按钮对话框处理方法
  private handleConfirmCancel() {
    // 取消操作，不做任何处理
    this.showThreeButtonConfirm = false;
  }

  private handleConfirmDelete() {
    // 删除实体
    DeleteShiti(this, this.clickData._id).then((res: any) => {
      this.$message.success("删除成功");
      const tree: any = this.$refs.tree;
      if (tree && this.clickData.uid) {
        const node = tree.getNode(this.clickData.uid);
        if (node) {
          tree.remove(node);
        }
        tree.setCurrentKey(null);
      }
      this.$message.success("删除成功");
      this.showThreeButtonConfirm = false;
      this.clickData = {};
      this.clickType = "";
    });
  }

  private handleConfirmModify() {
    // 修改位置
    console.log("修改位置");
    const params: any = {
      语义类型: this.shitiData["语义类型"],
      上位概念: [],
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    PatchConceptualEntity(this, this.shitiData.id, params, loading).then(
      (res: any) => {
        loading.close();
        this.$message.success("修改位置成功");
        this.showThreeButtonConfirm = false;
        // 清空当前的选择
        this.clickData = {};
        this.clickType = "";
        this.shitiData = {};
        // 刷新树
        this.refreshTree();
      }
    );
  }
}
